import React from 'react';

import { mountRootParcel } from 'single-spa';
import Parcel from 'single-spa-react/parcel';

import { InvoicingConfig } from 'root/apps/QuoteMachineIntegration/common';
import { EditCreditLimitModalProps } from 'root/apps/QuoteMachineIntegration/state/EditCreditModalProps';
import { SystemJS } from 'root/apps/QuoteMachineIntegration/SystemJS';
import { getSessionData } from 'root/apps/QuoteMachineIntegration/utils/SessionData';
import { datadogRum } from 'root/datadog/datadogRum';

const EditCreditLimitModal = ({ onSubmit, open, setOpen }: EditCreditLimitModalProps) => {
  return (
    <Parcel
      mountParcel={mountRootParcel}
      skipCSSUnmount={true}
      sessionData={getSessionData()}
      handleError={(err: Error) => datadogRum.addError(err)}
      open={open}
      setOpen={setOpen}
      onSubmit={onSubmit}
      config={async () =>
        (await SystemJS.import<InvoicingConfig>('@lightspeed/invoicing')).default
          .EditCreditLimitModalConfig
      }
    />
  );
};

export default EditCreditLimitModal;
